
import React, { useEffect, useState, useRef } from "react";

// reactstrap components
import {
  Col
} from "reactstrap";
import {
  Select1,
} from "components/input/elementos"; // componente input que incluye algunas de las funcionalidades como, setInput, validaciones cambio de estados
import { URL, INPUT } from "Auth/config";
import { start } from 'service'

import Links from "./links";
import axios from "axios";

function Folletos() {

  const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null });
  const [lista, setLista] = useState([])
  const [listaCategoria, setListaCategoria] = useState([])  // idTipo de gasto desde la bd
  const [anterior, setAnterior] = useState(100000000);
  const loaderRef = useRef(null);
  const [page, setPage] = useState(1);




  const fetchPDFs = (page) => {
    start(URL + '/public/listar-folletos-public', { anterior, dato: inputBuscar.campo }).then(j => {
      let newPDFs = []
      let c = 1
      for (let i of j[0]) {
        newPDFs.push({
          id: i.id,
          url: URL + 'pdf/' + i.id + '.pdf',
          views: i.views,
          fecha: i.fecha,
          titulo: i.titulo,
          descripcion: i.descripcion,
          categoria: i.categoria,
          autor: i.autor,
        });
        if (c == 4) {
          setAnterior(i.id)
        }
        c++
      }
      setListaCategoria(j[1])
      setLista((prevPDFs) => [...prevPDFs, ...newPDFs]);
    })



  };




  useEffect(() => {
    document.title = "FOLLETOS-IEC";
    fetchPDFs(page);
  }, [page]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      },
      { threshold: 1.0 }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, []);




  return (
    <div className="contentSimple"  >
      <div className="main-container">


        <header>
          <h1>IECC <br /> <span>[ contenido de sencibilizacion en PDF]</span></h1>

        </header>

        <Col md={5} className="mt-2 mb-2">
          <Select1
            estado={inputBuscar}
            cambiarEstado={setInputBuscar}
            name="sub_categoria"
            lista={listaCategoria}
            ExpresionRegular={INPUT.ID} //expresion regular
            // funcion={buscar}
            importante={false}
            opcion={'Seleccionar Categoria'}
          />
        </Col>

        <div className="pdf-gallery">
          {lista.map((e, index) => (
            <div className="pdf-container" style={{
              opacity: 0,
              animation: `fadeInUp 0.6s ease forwards ${index * 0.2}s`
            }}
            >
              <div className="pdf-preview">
                <iframe
                  src={`${URL}pdf/${e.id}.pdf`}
                  title={e.titulo}
                  className="pdf-frame"
                  style={{
                    width: '100%',
                    height: window.innerWidth <= 768 ? '200px' : '250px',
                    border: 'none'
                  }}
                />
                <div className="pdf-overlay">
                  <a href={`${URL}pdf/${e.id}.pdf`} target="_blank" rel="noopener noreferrer" className="view-pdf-btn" onClick={() => {
                    axios.post(URL + '/public/contar-visita', { id: e.id })
                    for (let item of lista) {
                      if (item.id === e.id) {
                        item.views++
                      }
                    }
                  }}>
                    <i className="tim-icons icon-zoom-split mr-1"></i>
                    Ver PDF
                  </a>
                </div>
              </div>
              <div className="pdf-info">
                <h3 style={{ marginBottom: '0.5rem', fontSize: '11px' }}>{e.titulo}</h3>
                <p style={{ marginBottom: '0.5rem', fontSize: '10px' }}>{e.descripcion}</p>
                <p style={{ marginBottom: '0.5rem', fontSize: '10px' }}>{e.subcategoria}</p>
                <p style={{ marginBottom: '0.5rem', fontSize: '9px', fontWeight: '600' }}>{e.autor}</p>

                <div className="pdf-metadata">
                  <span className="fecha">
                    <i className="tim-icons icon-calendar-60 mr-1"></i>
                    {new Date(e.fecha).toLocaleDateString('es-ES')}
                  </span>
                  <span className="visualizaciones">
                    <i className="tim-icons icon-eye-2 mr-1"></i>
                    {e.views} visualizaciones
                  </span>
                </div>
              </div>
            </div>
          ))}
          <div ref={loaderRef} style={{ height: "50px", backgroundColor: "lightgray", marginTop: "10px" }}>
            Cargando más folletos...
          </div>
          <style>{`
                  .pdf-gallery {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 2rem;
                  }

                  .pdf-container {
                    background: #fff;
                    border-radius: 12px;
                    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
                    overflow: hidden;
                    transition: all 0.3s ease;
                  }

                  .pdf-container:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 12px 24px rgba(0,0,0,0.15);
                  }

                  .pdf-preview {
                    position: relative;
                    background: #f5f5f5;
                    overflow: hidden;
                  }

                  .pdf-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.7);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    opacity: 0;
                    transition: opacity 0.3s ease;
                  }

                  .pdf-container:hover .pdf-overlay {
                    opacity: 1;
                  }

                  .view-pdf-btn {
                    background: #4FC3F7;
                    color: white;
                    padding: 0.8rem 1.5rem;
                    border-radius: 25px;
                    text-decoration: none;
                    font-weight: bold;
                    transform: scale(0.9);
                    transition: all 0.3s ease;
                  }

                  .view-pdf-btn:hover {
                    transform: scale(1);
                    background: #2196F3;
                  }

                  .pdf-info {
                    padding: 1.5rem;
                  }

                  .pdf-info h3 {
                    color: #2c3e50;
                    font-size: 1.2rem;
                    margin-bottom: 0.5rem;
                  }

                  .pdf-info p {
                    color: #666;
                    font-size: 0.9rem;
                    line-height: 1.4;
                    margin-bottom: 1rem;
                  }

                  .pdf-metadata {
                    display: flex;
                    justify-content: space-between;
                    font-size: 0.8rem;
                    color: #888;
                  }

                  @keyframes fadeInUp {
                    from {
                      opacity: 0;
                      transform: translateY(20px);
                    }
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }

                  @media (max-width: 768px) {
                    .pdf-gallery {
                      grid-template-columns: 1fr;
                      gap: 1rem;
                      padding: 0.5rem;
                    }

                    .pdf-info {
                      padding: 1rem;
                    }

                    .pdf-info h3 {
                      font-size: 1rem;
                    }

                    .pdf-metadata {
                      flex-direction: column;
                      gap: 0.5rem;
                    }
                  }
                `}</style>
        </div>




        <Links />

      </div>
    </div >
  );
}

export default Folletos;
